import { useEffect, useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import PdfFile from './icons/PdfFile';

type Facility = 'josef' | 'wilhelm';

interface Props {
  facility: Facility
}

const MedProdRegPanel = ({ facility }: Props) => {
  const { token } = useAuth();
  const [medProducts, setMedProducts] = useState<any[]>([]);

  const bullet = '🟢'; // using an emoji here

  const pdfs = {
    'josef': 'Medizinprodukteregister_Josefstadt.pdf',
    'wilhelm': 'Medizinprodukteregister_Wilhelmshöhe.pdf'
  };

  useEffect(() => {
    fetch('/api/med_products/' + facility, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(setMedProducts);
  }, [token]);

  return (
    <>
      <h5>13.11.2025</h5>
      <div>
        <Button variant="secondary" size="sm" className="mb-2" onClick={() => {
          window.open(`/api/pdfs/${encodeURIComponent(pdfs[facility])}`, '_blank');
        }}>
          <PdfFile />
          <span style={{ marginRight: '8px', marginLeft: '8px' }}>PDF Download</span>
        </Button>
      </div>
      <Table striped bordered className='med-reg-table'>
        <thead>
          <tr className='med_prod_head'>
            <th className='inspection'>Prüfung</th>
            <th className='productname'>Name/Bezeichnung</th>
            <th className='location'>Ort</th>
            <th className='model_nr'>Fabr.-Nr.</th>
            <th className='inventory_nr'>Inventarnummer</th>
            <th className='inspection_report_available'>Protokoll vorhanden</th>
            <th className='inspection_report_nr'>Protokoll Nr</th>
            <th className='audited_by'>Geprüft von</th>
            <th className='inspection_interval'>Prüfintervall [Monate]</th>
            <th className='last_inspection'>Letzte STK/MTK am:</th>
            <th className='status1'>Status</th>
            <th className='next_inspection2'>Nächster Termin spätestens</th>
            <th className='status2'>Status</th>
            <th className='next_inspection3'>Nächster Termin</th>
            <th className='status3'>Status</th>
          </tr>
        </thead>
        <tbody>
          {medProducts.map(mp => (
            <tr key={mp.id} className='med_prod_body'>
              <td title={mp.inspection_label} className='inspection'>{mp.inspection}</td>
              <td className='productname'>{mp.productname}</td>
              <td className='location'>{mp.location}</td>
              <td className='model_nr'>{mp.model_nr}</td>
              <td className='inventory_nr'>{mp.inventory_nr}</td>
              <td className='inspection_report_available'>{mp.inspection_report_available}</td>
              <td className='inspection_report_nr'>{mp.inspection_report_nr}</td>
              <td className='audited_by'>{mp.audited_by}</td>
              <td className='inspection_interval'>{mp.inspection_interval}</td>
              <td className='last_inspection'>{mp.last_inspection}</td>
              <td title={mp.status1_label} className='status1'>{mp.status1}</td>
              <td className='next_inspection2'>{mp.next_inspection2}</td>
              <td className='status2'>{mp.status2 === 'OK' ? bullet : ''}</td>
              <td className='next_inspection3'>{mp.next_inspection3}</td>
              <td className='status3'>{mp.status3}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default MedProdRegPanel;
